<template>
    <div class="ct-top-box">
      <div class="ct-title">
        <h1>{{ this.title }}</h1>
      </div>
      <p>
        {{ this.description }}
      </p>
    </div>
</template>

<script>
export default {
  name: "PageContent",
  props: ["title", "description"],
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/generator/PageContent.vue